module.exports = __webpack_public_path__ + "fa-solid-900.svg?506bcfeaad71580149d11c8fb36af219";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/fontAwesome-5/webfonts/fa-solid-900.svg
// module id = 369
// module chunks = 0